<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .tc,.table{
    margin-top: 20px!important;
  }
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_13.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>真菌基因组</h1>-->
<!--          <h2 class="mt10">Fungal genome（二代+三代ONT）</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>真菌基因组测序</h1>
      <h2 class="mt10">Fungal Genome（二代+三代ONT）</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">真菌基因组近完成图是采用Oxford Nanopore三代测序技术平台，获得高质量的真菌基因组图谱，使组装达到近完成图水平，更利于后续该真菌的相关研究。真菌基因组因为比细菌基因组更加复杂，在结构上和动植物基因组比较类似，所以传统的二代测序技术只能得到真菌基因组的草图，会丢失很多基因组信息，对基因的注释也会带来影响，而基于Oxford Nanopore的三代测序充分发挥了超长读长的优势，对真菌基因组上的复杂区域能更好的覆盖，在组装上contig N50可以达到Mb以上级别，组装的准确性可提高100倍。</p>
      <div class="c-title">项目流程</div>
      <div class="tc"><img src="@/assets/images/fungal_1.png"> </div>
      <div class="c-title">技术参数</div>
      <table class="table">
        <tr>
          <th style="width:350px;">参数</th>
          <th>细菌基因组完成图</th>
        </tr>
        <tr>
          <td>技术平台</td>
          <td>Illumina+Oxford Nanopore</td>
        </tr>
        <tr>
          <td>DNA质检</td>
          <td>双链DNA浓度 > 50 ng/μL，总量 > 10 μg，DNA片段 > 15 kb</td>
        </tr>
        <tr>
          <td>测序策略</td>
          <td>Illumina测序：350 bp文库，PE150测序Nanopore测序：10 ～ 20 kb文库，平均读长 > 10 kb</td>
        </tr>
        <!-- <tr>
          <td>测序数据量</td>
          <td>Illumina测序：最少1 GNanopore测序：最少100X数据量</td>
        </tr> -->
        <tr>
          <td>组装指标</td>
          <td>Contig N50大于1Mb，基因区覆盖度大于98%， 基因组覆盖度大于95%</td>
        </tr>
        <tr>
          <td>项目周期</td>
          <td>40个自然日</td>
        </tr>
      </table>
      <div class="c-title">生信分析流程</div>
      <div class="tc"><img src="@/assets/images/fungal_2.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/fungal.vue